import React, { useState, useEffect } from "react";
import axios from "axios";
import MaterialTable from "material-table";
import jsPDF from "jspdf";
import { ToastContainer, toast } from 'react-toastify';
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'


import Helper from "../../../../../Helper";
import { getTrans as t } from "../../../../../Localization/translations";
import { API } from "../../../../../backend";
import authHeader from "../../../../../services/auth-header";

const ContractLineOfCreditPaymentDetails = ({
  contractDate,
  paymentRule,
  payment_count,
  paymentFrequency,
  noTerms,
  items,
  contracttype,
  paymentdetails
}) => {
  const [paymentDates, setPaymentDates] = useState([]);
  const [feedefination, setFeeDefination] = useState([]);
  const FeeDefination = () => {
    let url =
      API +
      "contracts/feedefination-view/?feename=Payment Schedule&&active=Yes";
    axios
      .get(url, { headers: authHeader() })
      .then((response) => setFeeDefination(response.data))
  };
  useEffect(() => {
    FeeDefination();
  }, []);
  const getLastDayOfMonth = (year, month) => {
    return new Date(year, month + 1, 0);
  };
  //  useEffect(() => {
  //   if (paymentFrequency && payment_count > 0) {
  //     const contractDateObj = new Date(contractDate);
  //     const frequencyMapping = {
  //       Monthly: 1,
  //       Quarterly: 3,
  //       "Semi-annual": 6,
  //       Annual: 12,
  //     };

  //     const calculatedPaymentDates = [];
  //     let currentDate = contractDateObj;
  //     let paymentStartDate = null;
  //     let lastPaymentType = [];

  //     items.forEach((item, index) => {
  //       const { amount, periods, payment_type, start_date, end_date } = item;
  //       const filterfeenature = feedefination.filter(
  //         (value) => value.fee_name === payment_type
  //       );

  //       currentDate = new Date(start_date);

  //       if (amount && periods > 0) {
  //         if (paymentRule === "Advance") {
  //           paymentStartDate = contractDateObj;
  //         } else if (paymentRule === "Arrears") {
  //           const cycleMonths = frequencyMapping[paymentFrequency];
  //           paymentStartDate = new Date(
  //             contractDateObj.getFullYear(),
  //             contractDateObj.getMonth() + cycleMonths,
  //             contractDateObj.getDate()
  //           );
  //         }

  //         for (let i = 0; i < periods; i++) {
  //           let startDate = new Date(currentDate);
  //           let endDate = new Date(
  //             startDate.getFullYear(),
  //             startDate.getMonth() + frequencyMapping[paymentFrequency],
  //             startDate.getDate() - 1
  //           );

  //           if (filterfeenature.length !== 0 && filterfeenature[0].fee_nature === "One Time") {
  //             startDate = new Date(start_date);
  //             endDate = new Date(end_date);
  //           }

  //           const paymentEntry = {
  //             paymentdate:
  //               paymentRule === "Arrears"
  //                 ? Helper.DatePicker(endDate)
  //                 : Helper.DatePicker(paymentStartDate),
  //             startdate: Helper.DatePicker(startDate),
  //             enddate: Helper.DatePicker(endDate),
  //             periodicamount: amount,
  //             txn_number: `TRAN${index + 1}`,
  //             payment_type: payment_type,
  //           };

  //           calculatedPaymentDates.push(paymentEntry);

  //           currentDate = new Date(
  //             currentDate.getFullYear(),
  //             currentDate.getMonth() + frequencyMapping[paymentFrequency],
  //             currentDate.getDate()
  //           );

  //           paymentStartDate = new Date(
  //             paymentStartDate.getFullYear(),
  //             paymentStartDate.getMonth() + frequencyMapping[paymentFrequency],
  //             paymentStartDate.getDate()
  //           );
  //         }

  //         lastPaymentType[payment_type] = paymentStartDate;
  //       }
  //     });

  //     setPaymentDates(calculatedPaymentDates);
  //   }
  // }, [
  //   contractDate,
  //   paymentRule,
  //   paymentFrequency,
  //   noTerms,
  //   items,
  //   feedefination,
  //   payment_count,
  // ]);

  // useEffect(() => {
  //   if (paymentFrequency && payment_count > 0) {
  //     const contractDateObj = new Date(contractDate);
  //     const frequencyMapping = {
  //       Monthly: 1,
  //       Quarterly: 3,
  //       "Semi-annual": 6,
  //       Annual: 12,
  //     };

  //     const calculatedPaymentDates = [];
  //     let currentDate = contractDateObj;
  //     let paymentStartDate = null;
  //     let lastPaymentType = {};
  //     let startDate = null;
  //     let endDate = null;

  //     const isLeapYear = (year) => {
  //       return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  //     };

  //     const getLastDayOfMonth = (year, month) => {
  //       return new Date(year, month + 1, 0).getDate();
  //     };

  //     items.forEach((item, index) => {
  //       const { amount, periods, payment_type, start_date, end_date } = item;
  //       const filterfeenature = feedefination.filter(
  //         (value) => value.fee_name === payment_type
  //       );

  //       currentDate = new Date(start_date);
  //       const contractDay = contractDateObj.getDate();

  //       if (amount && periods > 0) {
  //         if (paymentRule === "Advance") {
  //           paymentStartDate = lastPaymentType[payment_type] || contractDateObj;
  //         } else if (paymentRule === "Arrears") {
  //           const cycleMonths = frequencyMapping[paymentFrequency];
  //           paymentStartDate = lastPaymentType[payment_type]
  //             ? new Date(
  //                 lastPaymentType[payment_type].getFullYear(),
  //                 lastPaymentType[payment_type].getMonth() + cycleMonths,
  //                 lastPaymentType[payment_type].getDate()
  //               )
  //             : new Date(
  //                 contractDateObj.getFullYear(),
  //                 contractDateObj.getMonth() + cycleMonths,
  //                 contractDateObj.getDate()
  //               );
  //         }

  //         for (let i = 0; i < periods; i++) {
  //           startDate = new Date(currentDate);

  //           const nextMonth = startDate.getMonth() + frequencyMapping[paymentFrequency];
  //           const nextYear = startDate.getFullYear() + Math.floor(nextMonth / 12);
  //           const adjustedNextMonth = nextMonth % 12;

  //           const nextLastDay = getLastDayOfMonth(nextYear, adjustedNextMonth);
  //           const nextDay = Math.min(contractDay, nextLastDay);

  //           // Adjust for end dates and leap years
  //           if (adjustedNextMonth === 1 && contractDay > 28) {
  //             if (isLeapYear(nextYear)) {
  //               endDate = new Date(nextYear, adjustedNextMonth, 29);
  //             } else {
  //               endDate = new Date(nextYear, adjustedNextMonth, 28);
  //             }
  //           } else {
  //             endDate = new Date(nextYear, adjustedNextMonth, nextDay);
  //           }

  //           if (filterfeenature.length !== 0 && filterfeenature[0].fee_nature === "One Time") {
  //             startDate = new Date(start_date);
  //             endDate = new Date(end_date);
  //           }

  //           const paymentEntry = {
  //             paymentdate: paymentRule === "Arrears" ? Helper.DatePicker(new Date(endDate.getTime() - 24 * 60 * 60 * 1000)) : Helper.DatePicker(new Date(paymentStartDate.getTime() - 24 * 60 * 60 * 1000)),
  //             startdate: Helper.DatePicker(startDate),
  //             enddate: Helper.DatePicker(new Date(endDate.getTime() - 24 * 60 * 60 * 1000)),
  //             periodicamount: amount,
  //             txn_number: `TRAN${index + 1}`,
  //             payment_type: payment_type,
  //           };

  //           calculatedPaymentDates.push(paymentEntry);

  //           currentDate = new Date(
  //             currentDate.getFullYear(),
  //             currentDate.getMonth() + frequencyMapping[paymentFrequency],
  //             nextDay
  //           );

  //           paymentStartDate = new Date(
  //             paymentStartDate.getFullYear(),
  //             paymentStartDate.getMonth() + frequencyMapping[paymentFrequency],
  //             nextDay
  //           );
  //         }

  //         lastPaymentType[payment_type] = paymentStartDate;
  //       }
  //     });

  //     setPaymentDates(calculatedPaymentDates);
  //   }
  // }, [
  //   contractDate,
  //   paymentRule,
  //   paymentFrequency,
  //   noTerms,
  //   items,
  //   feedefination,
  //   payment_count,
  // ]);

  //   useEffect(() => {
  //     if (paymentFrequency && payment_count > 0) {
  //         const contractDateObj = new Date(contractDate);
  //         const frequencyMapping = {
  //             Monthly: 1,
  //             Quarterly: 3,
  //             "Semi-annual": 6,
  //             Annual: 12,
  //         };

  //         const calculatedPaymentDates = [];
  //         let currentDate = new Date(contractDateObj);
  //         let paymentStartDate = null;
  //         let lastPaymentType = {};
  //         let startDate = null;
  //         let endDate = null;

  //         const isLeapYear = (year) => {
  //             return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  //         };

  //         const getLastDayOfMonth = (year, month) => {
  //             return new Date(year, month + 1, 0).getDate();
  //         };

  //         items.forEach((item, index) => {
  //             const { amount, periods, payment_type, start_date, end_date } = item;
  //             const filterfeenature = feedefination.filter(
  //                 (value) => value.fee_name === payment_type
  //             );

  //             currentDate = new Date(start_date);

  //             if (amount && periods > 0) {
  //                 if (paymentRule === "Advance") {
  //                     paymentStartDate = lastPaymentType[payment_type] || contractDateObj;
  //                 } else if (paymentRule === "Arrears") {
  //                     const cycleMonths = frequencyMapping[paymentFrequency];
  //                     paymentStartDate = lastPaymentType[payment_type]
  //                         ? new Date(
  //                             lastPaymentType[payment_type].getFullYear(),
  //                             lastPaymentType[payment_type].getMonth() + cycleMonths,
  //                             lastPaymentType[payment_type].getDate()
  //                         )
  //                         : new Date(
  //                             contractDateObj.getFullYear(),
  //                             contractDateObj.getMonth() + cycleMonths,
  //                             contractDateObj.getDate()
  //                         );
  //                 }

  //                 for (let i = 0; i < periods; i++) {
  //                     startDate = new Date(currentDate);

  //                     // Calculate the next payment period
  //                     const nextMonth = startDate.getMonth() + frequencyMapping[paymentFrequency];
  //                     const nextYear = startDate.getFullYear() + Math.floor(nextMonth / 12);
  //                     const adjustedNextMonth = nextMonth % 12;

  //                     // Set endDate to the last day of the adjusted next month
  //                     const lastDayOfMonth = getLastDayOfMonth(nextYear, adjustedNextMonth);

  //                     // Handle leap year cases for February
  //                     if (adjustedNextMonth === 1 && isLeapYear(nextYear) && startDate.getDate() > 28) {
  //                         endDate = new Date(nextYear, adjustedNextMonth, 29);
  //                     } else {
  //                         endDate = new Date(nextYear, adjustedNextMonth, lastDayOfMonth);
  //                     }

  //                     if (filterfeenature.length !== 0 && filterfeenature[0].fee_nature === "One Time") {
  //                         startDate = new Date(start_date);
  //                         endDate = new Date(end_date);
  //                     }

  //                     const paymentEntry = {
  //                         // paymentdate: Helper.DatePicker(paymentRule === "Arrears" ? new Date(endDate.getTime() - 24 * 60 * 60 * 1000) : new Date(paymentStartDate.getTime() - 24 * 60 * 60 * 1000)),
  //                         paymentdate: Helper.DatePicker(paymentRule === "Arrears" ? new Date(endDate) : new Date(paymentStartDate)),
  //                         startdate: Helper.DatePicker(startDate),
  //                         enddate: Helper.DatePicker(endDate),
  //                         periodicamount: amount,
  //                         txn_number: `TRAN${index + 1}`,
  //                         payment_type: payment_type,
  //                     };

  //                     calculatedPaymentDates.push(paymentEntry);

  //                     // Move to the next period
  //                     currentDate = new Date(
  //                         startDate.getFullYear(),
  //                         startDate.getMonth() + frequencyMapping[paymentFrequency],
  //                         startDate.getDate()
  //                     );

  //                     paymentStartDate = new Date(
  //                         paymentStartDate.getFullYear(),
  //                         paymentStartDate.getMonth() + frequencyMapping[paymentFrequency],
  //                         paymentStartDate.getDate()
  //                     );
  //                 }

  //                 lastPaymentType[payment_type] = paymentStartDate;
  //             }
  //         });

  //         setPaymentDates(calculatedPaymentDates);
  //     }
  // }, [
  //     contractDate,
  //     paymentRule,
  //     paymentFrequency,
  //     noTerms,
  //     items,
  //     feedefination,
  //     payment_count,
  // ]);


  useEffect(() => {
    if (contracttype === "Line of Credit") {
      setPaymentDates(paymentdetails);
    }
    else {
      if (paymentFrequency && payment_count > 0) {
        const contractDateObj = new Date(contractDate);
        const frequencyMapping = {
          Monthly: 1,
          Quarterly: 3,
          "Semi-annual": 6,
          Annual: 12,
        };

        const calculatedPaymentDates = [];
        let currentDate = contractDateObj;
        let paymentStartDate = null;
        let lastPaymentType = {};
        let startDate = null;
        let endDate = null;

        const isLeapYear = (year) => {
          return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
        };

        const getLastDayOfMonth = (year, month) => {
          return new Date(year, month + 1, 0).getDate();
        };

        items.forEach((item, index) => {
          const { amount, periods, payment_type, start_date, end_date } = item;
          const filterfeenature = feedefination.filter(
            (value) => value.fee_name === payment_type
          );

          currentDate = new Date(start_date);
          const contractDay = contractDateObj.getDate();

          if (amount >= 0 && periods > 0) {
            if (paymentRule === "Advance") {
              paymentStartDate = lastPaymentType[payment_type] || contractDateObj;
            } else if (paymentRule === "Arrears") {
              const cycleMonths = frequencyMapping[paymentFrequency];
              paymentStartDate = lastPaymentType[payment_type]
                ? new Date(
                  lastPaymentType[payment_type].getFullYear(),
                  lastPaymentType[payment_type].getMonth() + cycleMonths,
                  lastPaymentType[payment_type].getDate()
                )
                : new Date(
                  contractDateObj.getFullYear(),
                  contractDateObj.getMonth() + cycleMonths,
                  contractDateObj.getDate()
                );
            }

            for (let i = 0; i < periods; i++) {
              startDate = new Date(currentDate);

              const nextMonth = startDate.getMonth() + frequencyMapping[paymentFrequency];
              const nextYear = startDate.getFullYear() + Math.floor(nextMonth / 12);
              const adjustedNextMonth = nextMonth % 12;

              const nextLastDay = getLastDayOfMonth(nextYear, adjustedNextMonth);
              const nextDay = Math.min(contractDay, nextLastDay);

              // Adjust for end dates and leap years
              if (adjustedNextMonth === 1 && contractDay > 28) {
                if (isLeapYear(nextYear)) {
                  endDate = new Date(nextYear, adjustedNextMonth, 30);
                } else {
                  endDate = new Date(nextYear, adjustedNextMonth, 29);
                }
              } else {
                endDate = new Date(nextYear, adjustedNextMonth, contractDateObj.getDate());
              }

              if (filterfeenature.length !== 0 && filterfeenature[0].fee_nature === "One Time") {
                startDate = new Date(start_date);
                endDate = new Date(end_date);
              }

              const paymentEntry = {
                paymentdate: paymentRule === "Arrears" ? Helper.DatePicker(new Date(endDate.getTime() - 24 * 60 * 60 * 1000)) : Helper.DatePicker(new Date(paymentStartDate)),
                startdate: Helper.DatePicker(startDate),
                enddate: Helper.DatePicker(new Date(endDate.getTime() - 24 * 60 * 60 * 1000)),
                periodicamount: amount,
                txn_number: `TRAN${index + 1}`,
                payment_type: payment_type,
              };

              calculatedPaymentDates.push(paymentEntry);

              currentDate = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth() + frequencyMapping[paymentFrequency],
                Math.min(
                  currentDate.getDate(),
                  getLastDayOfMonth(currentDate.getFullYear(), currentDate.getMonth() + frequencyMapping[paymentFrequency])
                )
              );

              if (contractDay > getLastDayOfMonth(currentDate.getFullYear(), currentDate.getMonth())) {
                currentDate.setDate(getLastDayOfMonth(currentDate.getFullYear(), currentDate.getMonth()));
              }

              paymentStartDate = new Date(
                paymentStartDate.getFullYear(),
                paymentStartDate.getMonth() + frequencyMapping[paymentFrequency],
                Math.min(
                  paymentStartDate.getDate(),
                  getLastDayOfMonth(paymentStartDate.getFullYear(), paymentStartDate.getMonth() + frequencyMapping[paymentFrequency])
                )
              );
            }

            lastPaymentType[payment_type] = paymentStartDate;
          }
        });

        setPaymentDates(calculatedPaymentDates);
      }
    }
  }, [
    contractDate,
    paymentRule,
    paymentFrequency,
    noTerms,
    items,
    feedefination,
    payment_count,
    paymentdetails
  ]);





  //Perfect paymentdetails
  // useEffect(() => {
  //   if (paymentFrequency && payment_count > 0) {
  //     const contractDateObj = new Date(contractDate);
  //     const frequencyMapping = {
  //       Monthly: 1,
  //       Quarterly: 3,
  //       "Semi-annual": 6,
  //       Annual: 12,
  //     };

  //     const calculatedPaymentDates = [];
  //     let currentDate = contractDateObj;
  //     let paymentStartDate = null;
  //     let lastPaymentType = {};
  //     let startDate = null;
  //     let endDate = null;

  //     const isLeapYear = (year) => {
  //       return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  //     };

  //     const getLastDayOfMonth = (year, month) => {
  //       return new Date(year, month + 1, 0).getDate();
  //     };

  //     items.forEach((item, index) => {
  //       const { amount, periods, payment_type, start_date, end_date } = item;
  //       const filterfeenature = feedefination.filter(
  //         (value) => value.fee_name === payment_type
  //       );

  //       currentDate = new Date(start_date);
  //       const isLastDayOfMonth =
  //         contractDateObj.getDate() === new Date(
  //           contractDateObj.getFullYear(),
  //           contractDateObj.getMonth() + 1,
  //           0
  //         ).getDate();

  //       if (amount && periods > 0) {
  //         if (paymentRule === "Advance") {
  //           paymentStartDate = lastPaymentType[payment_type] || contractDateObj;
  //         } else if (paymentRule === "Arrears") {
  //           const cycleMonths = frequencyMapping[paymentFrequency];
  //           paymentStartDate = lastPaymentType[payment_type]
  //             ? new Date(
  //                 lastPaymentType[payment_type].getFullYear(),
  //                 lastPaymentType[payment_type].getMonth() + cycleMonths,
  //                 lastPaymentType[payment_type].getDate()
  //               )
  //             : new Date(
  //                 contractDateObj.getFullYear(),
  //                 contractDateObj.getMonth() + cycleMonths,
  //                 contractDateObj.getDate()
  //               );
  //         }

  //         for (let i = 0; i < periods; i++) {
  //           startDate = new Date(currentDate);

  //           if (isLastDayOfMonth) {
  //             const nextMonth = startDate.getMonth() + frequencyMapping[paymentFrequency];
  //             if(isLeapYear(startDate.getFullYear())){

  //               endDate = new Date(
  //                 startDate.getFullYear(),
  //                 nextMonth,
  //                 Math.max(contractDateObj.getDate()-1,29)
  //               );
  //             }
  //             else{
  //               if (nextMonth % 12 ===1){

  //                 endDate = new Date(
  //                   startDate.getFullYear(),
  //                   nextMonth,
  //                   Math.min(contractDateObj.getDate()-1,28)
  //                 );
  //               }else{
  //                 endDate = new Date(
  //                   startDate.getFullYear(),
  //                   nextMonth,
  //                   contractDateObj.getDate()-1
  //                 );

  //               }

  //             }
  //             // endDate.setDate(endDate.getDate() - 1); // Subtract one day
  //           } else {
  //             endDate = new Date(
  //               currentDate.getFullYear(),
  //               currentDate.getMonth() + frequencyMapping[paymentFrequency],
  //               currentDate.getDate() - 1
  //             );
  //           }

  //           if (filterfeenature.length !== 0 && filterfeenature[0].fee_nature === "One Time") {
  //             startDate = new Date(start_date);
  //             endDate = new Date(end_date);
  //           }

  //           const paymentEntry = {
  //             paymentdate: paymentRule === "Arrears" ? Helper.DatePicker(endDate) : Helper.DatePicker(paymentStartDate),
  //             // startdate: Helper.DatePicker(startDate),
  //             startdate: Helper.DatePicker(startDate),
  //             enddate: Helper.DatePicker(endDate),
  //             periodicamount: amount,
  //             txn_number: `TRAN${index + 1}`,
  //             payment_type: payment_type,
  //           };

  //           calculatedPaymentDates.push(paymentEntry);

  //           currentDate = new Date(
  //             currentDate.getFullYear(),
  //             currentDate.getMonth() + frequencyMapping[paymentFrequency],
  //             Math.min(
  //               currentDate.getDate(),
  //               getLastDayOfMonth(currentDate.getFullYear(), currentDate.getMonth() + frequencyMapping[paymentFrequency])
  //             )
  //           );

  //           if (isLastDayOfMonth) {
  //             paymentStartDate = new Date(
  //               endDate.getFullYear(),
  //               endDate.getMonth() + frequencyMapping[paymentFrequency],
  //               endDate.getDate() - 1
  //             );
  //           } else {
  //             paymentStartDate = new Date(
  //               paymentStartDate.getFullYear(),
  //               paymentStartDate.getMonth() + frequencyMapping[paymentFrequency],
  //               Math.min(
  //                 paymentStartDate.getDate(),
  //                 getLastDayOfMonth(paymentStartDate.getFullYear(), paymentStartDate.getMonth() + frequencyMapping[paymentFrequency])
  //               )
  //             );
  //           }
  //         }

  //         lastPaymentType[payment_type] = paymentStartDate;
  //       }
  //     });

  //     setPaymentDates(calculatedPaymentDates);
  //   }
  // }, [
  //   contractDate,
  //   paymentRule,
  //   paymentFrequency,
  //   noTerms,
  //   items,
  //   feedefination,
  //   payment_count,
  // ]);



  // secomddddd-0-------------------------------
  //   useEffect(() => {
  //   if (paymentFrequency && payment_count > 0) {
  //     const contractDateObj = new Date(contractDate);
  //     const frequencyMapping = {
  //       Monthly: 1,
  //       Quarterly: 3,
  //       "Semi-annual": 6,
  //       Annual: 12,
  //     };

  //     const calculatedPaymentDates = [];
  //     let currentDate = new Date(contractDateObj);
  //     let paymentStartDate = null;
  //     let lastPaymentType = {};
  //     let startDate = null;
  //     let endDate = null;

  //     items.forEach((item, index) => {
  //       const { amount, periods, payment_type, start_date, end_date } = item;
  //       const filterfeenature = feedefination.filter(
  //         (value) => value.fee_name === payment_type
  //       );
  //       const isLastDayOfMonth =
  //         contractDateObj.getDate() ===
  //         new Date(
  //           contractDateObj.getFullYear(),
  //           contractDateObj.getMonth() + 1,
  //           0
  //         ).getDate();

  //       currentDate = new Date(start_date);

  //       if (amount && periods > 0) {
  //         if (paymentRule === "Advance") {
  //           if (typeof lastPaymentType[payment_type] === "undefined") {
  //             paymentStartDate = contractDateObj;
  //           } else {
  //             paymentStartDate = lastPaymentType[payment_type];
  //           }
  //         } else if (paymentRule === "Arrears") {
  //           const cycleMonths = frequencyMapping[paymentFrequency];
  //           if (typeof lastPaymentType[payment_type] === "undefined") {
  //             paymentStartDate = new Date(
  //               contractDateObj.getFullYear(),
  //               contractDateObj.getMonth() + cycleMonths,
  //               contractDateObj.getDate()
  //             );
  //           } else {
  //             paymentStartDate = lastPaymentType[payment_type];
  //           }
  //         }

  //         let calculatedNoTerms;
  //         switch (paymentFrequency) {
  //           case "Monthly":
  //             calculatedNoTerms = parseInt(noTerms) / 1;
  //             break;
  //           case "Quarterly":
  //             calculatedNoTerms = parseInt(noTerms) / 3;
  //             break;
  //           case "Annual":
  //             calculatedNoTerms = parseInt(noTerms) / 12;
  //             break;
  //           case "Semi-annual":
  //             calculatedNoTerms = parseInt(noTerms) / 6;
  //             break;
  //           default:
  //             throw new Error("Invalid payment frequency");
  //         }

  //         for (let i = 0; i < periods; i++) {
  //           startDate = new Date(
  //             currentDate.getFullYear(),
  //             currentDate.getMonth(),
  //             currentDate.getDate()
  //           );

  //           let nextMonth =
  //             startDate.getMonth() + frequencyMapping[paymentFrequency];
  //           let lastDayNextMonth = new Date(
  //             startDate.getFullYear(),
  //             nextMonth + 1,
  //             0
  //           ).getDate();

  //           // Check if next month is February and if it's a leap year
  //           if (nextMonth === 1) {
  //             const year = startDate.getFullYear();
  //             const isLeapYear =
  //               (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  //             if (isLeapYear) {
  //               endDate = new Date(
  //                 startDate.getFullYear(),
  //                 nextMonth,
  //                 Math.min(startDate.getDate(), 29)
  //               );
  //             } else {
  //               endDate = new Date(
  //                 startDate.getFullYear(),
  //                 nextMonth,
  //                 Math.min(startDate.getDate() - 1, 28)
  //               );
  //             }
  //           } else {
  //             endDate = new Date(
  //               startDate.getFullYear(),
  //               nextMonth,
  //               Math.min(startDate.getDate() - 1, lastDayNextMonth)
  //             );
  //           }

  //           const paymentDate = new Date(paymentStartDate);
  //           paymentDate.setDate(paymentDate.getDate() - 1); // Subtract one day from the contract date

  //           const paymentEntry = {
  //             paymentdate: Helper.DatePicker(paymentDate),
  //             startdate: Helper.DatePicker(startDate),
  //             enddate: Helper.DatePicker(endDate),
  //             periodicamount: amount,
  //             txn_number: `TRAN${index + 1}`,
  //             payment_type: payment_type,
  //           };

  //           calculatedPaymentDates.push(paymentEntry);

  //           currentDate = new Date(
  //             currentDate.getFullYear(),
  //             currentDate.getMonth() + frequencyMapping[paymentFrequency],
  //             currentDate.getDate()
  //           );

  //           if (isLastDayOfMonth === true) {
  //             paymentStartDate = new Date(
  //               endDate.getFullYear(),
  //               endDate.getMonth() + frequencyMapping[paymentFrequency],
  //               endDate.getDate() - 1
  //             );
  //           } else {
  //             paymentStartDate = new Date(
  //               paymentStartDate.getFullYear(),
  //               paymentStartDate.getMonth() + frequencyMapping[paymentFrequency],
  //               paymentStartDate.getDate()
  //             );
  //           }
  //         }

  //         lastPaymentType[payment_type] = paymentStartDate;
  //       }
  //     });

  //     setPaymentDates(calculatedPaymentDates);

  //     console.log("data--", calculatedPaymentDates);
  //   }
  // }, [
  //   contractDate,
  //   paymentRule,
  //   paymentFrequency,
  //   noTerms,
  //   items,
  //   feedefination,
  //   payment_count,
  // ]);

  // useEffect(() => {
  //   if (paymentFrequency && payment_count > 0) {
  //     const contractDateObj = new Date(contractDate);
  //     const frequencyMapping = {
  //       Monthly: 1,
  //       Quarterly: 3,
  //       "Semi-annual": 6,
  //       Annual: 12,
  //     };

  //     const calculatedPaymentDates = [];
  //     let currentDate = contractDateObj;
  //     let paymentStartDate = null;
  //     let lastPaymentType = [];
  //     let startDate = null;
  //     let endDate = null;

  //     const isLeapYear = (year) => {
  //       return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  //     };

  //     const getLastDayOfMonth = (year, month) => {
  //       return new Date(year, month + 1, 0).getDate();
  //     };

  //     items.forEach((item, index) => {
  //       const { amount, periods, payment_type, start_date, end_date } = item;
  //       const filterfeenature = feedefination.filter(
  //         (value) => value.fee_name === payment_type
  //       );

  //       currentDate = new Date(start_date);
  //       const isLastDayOfMonth =
  //         contractDateObj.getDate() === new Date(
  //           contractDateObj.getFullYear(),
  //           contractDateObj.getMonth() + 1,
  //           0
  //         ).getDate();

  //       if (amount && periods > 0) {
  //         if (paymentRule === "Advance") {
  //           paymentStartDate = lastPaymentType[payment_type] || contractDateObj;
  //         } else if (paymentRule === "Arrears") {
  //           const cycleMonths = frequencyMapping[paymentFrequency];
  //           paymentStartDate = lastPaymentType[payment_type]
  //             ? new Date(
  //                 lastPaymentType[payment_type].getFullYear(),
  //                 lastPaymentType[payment_type].getMonth() + cycleMonths,
  //                 lastPaymentType[payment_type].getDate()
  //               )
  //             : new Date(
  //                 contractDateObj.getFullYear(),
  //                 contractDateObj.getMonth() + cycleMonths,
  //                 contractDateObj.getDate()
  //               );
  //         }

  //         for (let i = 0; i < periods; i++) {
  //           startDate = new Date(currentDate);

  //           if (isLastDayOfMonth) {
  //             const nextMonth = startDate.getMonth() + frequencyMapping[paymentFrequency];
  //             endDate = new Date(
  //               startDate.getFullYear(),
  //               nextMonth + 1,
  //               0
  //             );
  //             endDate.setDate(endDate.getDate() - 1); // Subtract one day
  //           } else {
  //             endDate = new Date(
  //               currentDate.getFullYear(),
  //               currentDate.getMonth() + frequencyMapping[paymentFrequency],
  //               currentDate.getDate() - 1
  //             );
  //           }

  //           if (filterfeenature.length !== 0 && filterfeenature[0].fee_nature === "One Time") {
  //             startDate = new Date(start_date);
  //             endDate = new Date(end_date);
  //           }

  //           const paymentEntry = {
  //             paymentdate: paymentRule === "Arrears" ? Helper.DatePicker(endDate) : Helper.DatePicker(paymentStartDate),
  //             startdate: Helper.DatePicker(startDate),
  //             enddate: Helper.DatePicker(endDate),
  //             periodicamount: amount,
  //             txn_number: `TRAN${index + 1}`,
  //             payment_type: payment_type,
  //           };

  //           calculatedPaymentDates.push(paymentEntry);

  //           currentDate = new Date(
  //             currentDate.getFullYear(),
  //             currentDate.getMonth() + frequencyMapping[paymentFrequency],
  //             Math.min(
  //               currentDate.getDate(),
  //               getLastDayOfMonth(currentDate.getFullYear(), currentDate.getMonth() + frequencyMapping[paymentFrequency])
  //             )
  //           );

  //           if (isLastDayOfMonth) {
  //             paymentStartDate = new Date(
  //               endDate.getFullYear(),
  //               endDate.getMonth() + frequencyMapping[paymentFrequency],
  //               endDate.getDate() - 1
  //             );
  //           } else {
  //             paymentStartDate = new Date(
  //               paymentStartDate.getFullYear(),
  //               paymentStartDate.getMonth() + frequencyMapping[paymentFrequency],
  //               Math.min(
  //                 paymentStartDate.getDate(),
  //                 getLastDayOfMonth(paymentStartDate.getFullYear(), paymentStartDate.getMonth() + frequencyMapping[paymentFrequency])
  //               )
  //             );
  //           }
  //         }

  //         lastPaymentType[payment_type] = paymentStartDate;
  //       }
  //     });

  //     setPaymentDates(calculatedPaymentDates);
  //   }
  // }, [
  //   contractDate,
  //   paymentRule,
  //   paymentFrequency,
  //   noTerms,
  //   items,
  //   feedefination,
  //   payment_count,
  // ]);




  // useEffect(() => {
  //   if (paymentFrequency && payment_count > 0) {
  //     const contractDateObj = new Date(contractDate);
  //     const frequencyMapping = {
  //       Monthly: 1,
  //       Quarterly: 3,
  //       "Semi-annual": 6,
  //       Annual: 12,
  //     };

  //     const calculatedPaymentDates = [];
  //     let currentDate = contractDateObj;
  //     let paymentStartDate = null;
  //     let lastPaymentType = [];
  //     let startDate = null;
  //     let endDate = null;
  //     let value = "";

  //     items.forEach((item, index) => {
  //       const { amount, periods, payment_type, start_date, end_date } = item;
  //       const filterfeenature = feedefination.filter(
  //         (value) => value.fee_name === payment_type
  //       );
  //       const isLastDayOfMonth =
  //         contractDateObj.getDate() ===
  //         new Date(
  //           contractDateObj.getFullYear(),
  //           contractDateObj.getMonth() + 1,
  //           0
  //         ).getDate();
  //       currentDate = new Date(start_date);
  //       if (amount && periods > 0) {
  //         if (paymentRule === "Advance") {
  //           if (typeof lastPaymentType[payment_type] === "undefined") {
  //             paymentStartDate = contractDateObj;
  //           } else {
  //             paymentStartDate = lastPaymentType[payment_type];
  //           }
  //         } else if (paymentRule === "Arrears") {
  //           const cycleMonths = frequencyMapping[paymentFrequency];
  //           if (typeof lastPaymentType[payment_type] === "undefined") {
  //             paymentStartDate = new Date(
  //               contractDateObj.getFullYear(),
  //               contractDateObj.getMonth() + cycleMonths,
  //               contractDateObj.getDate()
  //             );
  //           } else {
  //             paymentStartDate = lastPaymentType[payment_type];
  //           }
  //         }

  //         let calculatedNoTerms;
  //         switch (paymentFrequency) {
  //           case "Monthly":
  //             calculatedNoTerms = parseInt(noTerms) / 1;
  //             break;
  //           case "Quarterly":
  //             calculatedNoTerms = parseInt(noTerms) / 3;
  //             break;
  //           case "Annual":
  //             calculatedNoTerms = parseInt(noTerms) / 12;
  //             break;
  //           case "Semi-annual":
  //             calculatedNoTerms = parseInt(noTerms) / 6;
  //             break;
  //           default:
  //             throw new Error("Invalid payment frequency");
  //         }

  //         for (let i = 0; i < periods; i++) {
  //           if (isLastDayOfMonth === true) {
  //             startDate = new Date(
  //               currentDate.getFullYear(),
  //               currentDate.getMonth(),
  //               currentDate.getDate() // Add one day to the start date
  //             );
  //           } else {
  //             startDate = new Date(
  //               currentDate.getFullYear(),
  //               currentDate.getMonth(),
  //               currentDate.getDate() // Add one day to the start date
  //             );
  //           }
  //           if (isLastDayOfMonth === true) {
  //             let lastDayCurrentMonth = getLastDayOfMonth(
  //               contractDateObj.getFullYear(),
  //               contractDateObj.getMonth(),
  //               contractDateObj.getDate()
  //             );
  //             let nextMonth =
  //               startDate.getMonth() + frequencyMapping[paymentFrequency];
  //             let lastDayNextMonth = new Date(
  //               startDate.getFullYear(),
  //               nextMonth + 1,
  //               0
  //             ).getDate();
  //             if (nextMonth === 1) {
  //               const year = startDate.getFullYear();
  //               const isLeapYear =
  //                 (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  //               if (isLeapYear) {
  //                 endDate = new Date(
  //                   startDate.getFullYear(),
  //                   nextMonth,
  //                   Math.min(startDate.getDate(), 29)
  //                 );
  //                 value = 1;
  //               } else {
  //                 endDate = new Date(
  //                   startDate.getFullYear(),
  //                   nextMonth,
  //                   Math.min(startDate.getDate() - 1, 28)
  //                 );
  //                 value = 1;
  //               }
  //             } else {
  //               if (value === 1) {

  //                 endDate = new Date(
  //                   startDate.getFullYear(),
  //                   nextMonth,
  //                   // lastDayCurrentMonth.getDate() - 1
  //                   Math.min(
  //                     lastDayCurrentMonth.getDate() - 1,
  //                     lastDayNextMonth
  //                   )
  //                 );
  //                 value = "";
  //               } else {
  //                 endDate = new Date(
  //                   startDate.getFullYear(),
  //                   startDate.getMonth() + frequencyMapping[paymentFrequency],
  //                   lastDayCurrentMonth.getDate() - 1
  //                   // Math.min(startDate.getDate() - 1,startDate.getDate()-1)
  //                 );
  //                 value = "";
  //                 // value=""
  //               }
  //               // endDate = new Date(
  //               //   startDate.getFullYear(),
  //               //   nextMonth,
  //               //   // lastDayCurrentMonth.getDate() - 1
  //               //   Math.min(lastDayCurrentMonth.getDate() - 1, lastDayNextMonth)
  //               // );
  //             }

  //             // endDate = new Date(
  //             //   startDate.getFullYear(),
  //             //   startDate.getMonth() + frequencyMapping[paymentFrequency],
  //             //   lastDayCurrentMonth.getDate() - 1
  //             // );
  //           } else {
  //             endDate = new Date(
  //               currentDate.getFullYear(),
  //               currentDate.getMonth() + frequencyMapping[paymentFrequency],
  //               currentDate.getDate() - 1
  //             );
  //           }
  //           if (filterfeenature.length !== 0) {
  //             if (filterfeenature[0].fee_nature === "One Time") {
  //               startDate = new Date(start_date);
  //               endDate = new Date(end_date);
  //             }
  //           }

  //           const paymentEntry = {
  //             paymentdate:
  //               paymentRule === "Arrears"
  //                 ? Helper.DatePicker(endDate)
  //                 : Helper.DatePicker(paymentStartDate),
  //             startdate: Helper.DatePicker(startDate),
  //             enddate: Helper.DatePicker(endDate),
  //             periodicamount: amount,
  //             txn_number: `TRAN${index + 1}`,
  //             payment_type: payment_type,
  //           };

  //           calculatedPaymentDates.push(paymentEntry);

  //           let nextMonth =
  //             startDate.getMonth() + frequencyMapping[paymentFrequency];
  //           // console.log("next startdate ----",startDate)
  //           // console.log("next month --------",nextMonth)
  //           let lastDayNextMonth = new Date(
  //             startDate.getFullYear(),
  //             nextMonth + 1,
  //             0
  //           ).getDate();
  //           if (nextMonth === 1) {
  //             const year = startDate.getFullYear();
  //             const isLeapYear =
  //               (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  //             if (isLeapYear) {
  //               currentDate = new Date(
  //                 // currentDate.getFullYear(),
  //                 // currentDate.getMonth() + frequencyMapping[paymentFrequency],
  //                 // currentDate.getDate()
  //                 currentDate.getFullYear(),
  //                 nextMonth,
  //                 Math.min(currentDate.getDate(), 29)
  //               );
  //               // value = 1
  //             } else {
  //               currentDate = new Date(
  //                 // currentDate.getFullYear(),
  //                 // currentDate.getMonth() + frequencyMapping[paymentFrequency],
  //                 // currentDate.getDate()
  //                 currentDate.getFullYear(),
  //                 nextMonth,
  //                 Math.min(currentDate.getDate() - 1, 28)
  //               );
  //               // value = 1
  //               // console.log("in Leap Year  date of ",c)
  //             }
  //           } else {
  //             currentDate = new Date(
  //               currentDate.getFullYear(),
  //               currentDate.getMonth() + frequencyMapping[paymentFrequency],
  //               currentDate.getDate()
  //             );
  //           }

  //           if (isLastDayOfMonth === true) {
  //             paymentStartDate = new Date(
  //               endDate.getFullYear(),
  //               endDate.getMonth() + frequencyMapping[paymentFrequency],
  //               endDate.getDate() - 1
  //             );
  //           } else {
  //             paymentStartDate = new Date(
  //               paymentStartDate.getFullYear(),
  //               paymentStartDate.getMonth() +
  //                 frequencyMapping[paymentFrequency],
  //               paymentStartDate.getDate()
  //             );
  //           }
  //         }

  //         lastPaymentType[payment_type] = paymentStartDate;
  //       }
  //     });
  //     // calculatedPaymentDates.sort((a, b) => {
  //     //   const dateA = new Date(a.paymentdate);
  //     //   const dateB = new Date(b.paymentdate);
  //     //   return dateA - dateB;
  //     // });
  //     setPaymentDates(calculatedPaymentDates);
  //   }
  // }, [
  //   contractDate,
  //   paymentRule,
  //   paymentFrequency,
  //   noTerms,
  //   items,
  //   feedefination,
  //   payment_count,
  // ]);

  return (
    <>
      <div className="mt">
        <MaterialTable
          style={{
            backgroundColor: "var(--bs-table-bg)",
            borderBottomWidth: "1px",
            boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
          }}
          title={
            <>
              <span className="required">{t("Payment Details")}</span> -{" "}
              <span style={{ fontSize: "14px" }}>
                Payment Details will be generated after Disbursements
              </span>
            </>
          }
          columns={[
            {
              title: `${t("Pmt No")}`,
              field: "pmt_no",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Pmt No")}
                  </div>
                  <div>{rowData.pmt_no}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Payment Date")}`,
              field: "paymentdate",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Payment Date")}
                  </div>
                  <div>{Helper.DateNormal(rowData.paymentdate)}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Payment Type")}`,
              field: "paymenttype",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Payment Type")}
                  </div>
                  {/* <div>{rowData.payment_type}</div> */}
                  <div>
                    {rowData.payment_type === "Rent"
                      ? "Payment"
                      : rowData.payment_type}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
              // hidden: contracttype === 'Loan' ? true : false
            },
            {
              title: `${t("Start Date")}`,
              field: "startdate",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Start Date")}
                  </div>
                  <div>{Helper.DateNormal(rowData.startdate)}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("End Date")}`,
              field: "enddate",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("End Date")}
                  </div>
                  <div>{Helper.DateNormal(rowData.enddate)}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Beginning Balance")}`,
              field: "beg_receivable",
              // field: "periodicamount",
              render: (rowData) => (
                <>
                  <div
                    className={`d-xl-none tc d-md-none d-lg-none`}
                    style={{
                      textAlign: rowData.isSmallScreen ? "left" : "right",
                      fontSize: "12px",
                      fontWeight: rowData.isSmallScreen ? "bold" : "",
                    }}
                  >
                    {t("Beginning Balance")}
                  </div>
                  <div
                    className={`d-none d-xl-block d-lg-block text-right`}
                    style={{ textAlign: "right", fontSize: "12px" }}
                  >
                    {/* {Helper.Amount(rowData.periodicamount)} */}
                    {Helper.Amount(rowData.beg_receivable)}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "right",
              },
              // cellStyle: {
              //   textAlign: "right",
              //   fontSize: 12,
              // },
            },
            {
              title: `${t("Amount")}`,
              field: "periodicamount_decimal2",
              // field: "periodicamount",
              render: (rowData) => (
                <>
                  <div
                    className={`d-xl-none tc d-md-none d-lg-none`}
                    style={{
                      textAlign: rowData.isSmallScreen ? "left" : "right",
                      fontSize: "12px",
                      fontWeight: rowData.isSmallScreen ? "bold" : "",
                    }}
                  >
                    {t("Amount")}
                  </div>
                  <div
                    className={`d-none d-xl-block d-lg-block text-right`}
                    style={{ textAlign: "right", fontSize: "12px" }}
                  >
                    {/* {Helper.Amount(rowData.periodicamount)} */}
                    {Helper.Amount(rowData.periodicamount_decimal2)}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "right",
              },
              // cellStyle: {
              //   textAlign: "right",
              //   fontSize: 12,
              // },
            },
            {
              title: `${t("Interest")}`,
              field: "interest_decimal2",
              render: rowData => <><div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
              >{t("Interest")}</div><div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.interest_decimal2)}</div></>,
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "right"
              },
              // cellStyle: {
              //     textAlign: "right",
              //     fontSize: 12
              // }
            },
            {
              title: `${t("Principal")}`,
              field: "principal_decimal2",
              render: rowData => <><div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
              >{t("Principal")}</div><div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.principal_decimal2)}</div></>,
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "right"
              },
              // cellStyle: {
              //     textAlign: "right",
              //     fontSize: 12
              // }
            },
            {
              title: `${t("Ending Balance")}`,
              // field: "principal_decimal2",
              field: "end_receivable",
              render: rowData => <><div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
              >{t("Ending Balance")}</div><div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                  {Helper.Amount(rowData.end_receivable)}</div></>,
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "right"
              },
              // cellStyle: {
              //     textAlign: "right",
              //     fontSize: 12
              // }
            },
            {
              title: `${t("Date Billed")}`,
              field: "date_billed",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Date Billed")}
                  </div>
                  <div>
                    {rowData.date_billed
                      ? Helper.DateNormal(rowData.date_billed)
                      : "None"}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Transaction Number")}`,
              field: "paymentdetail_id",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Transaction Number")}
                  </div>
                  <div>{rowData.paymentdetail_id}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
          ]}
          data={paymentDates}
          localization={{
            toolbar: {
              searchPlaceholder: "Search Contracts",
            },
          }}
          options={{
            headerStyle: {
              backgroundColor: "white",
              color: "#245C7F",
              fontSize: 11,
            },
            rowStyle: (rowData, index) => {
              if (index % 2) {
                return { backgroundColor: "#fff" };
              }
            },
            sorting: true,
            search: false,
            toolbar: true,
            paging: true,
            pageSize: 10, // make initial page size
            emptyRowsWhenPaging: false, // To avoid of having empty rows
            pageSizeOptions: [10, 20, 25, 50],
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            exportAllData: true,
            exportButton: true,
            exportFileName: "Payment Detail",
            exportPdf: (data, columns) => {
              const doc = new jsPDF();
              const columnTitles = data.map((columnDef) => columnDef.title);

              const pdfData = columns.map((rowData) =>
                data.map((columnDef) => rowData[columnDef.field])
              );
              // doc.autoTable({
              autoTable(doc, {
                head: [columnTitles],
                body: pdfData,
              });

              doc.save(`contract.pdf`);
            },
            actionsColumnIndex: -1,
          }}
        />
      </div>
    </>
  );
};

export default ContractLineOfCreditPaymentDetails;
